export const mockBulkReleaseHoldsResponse = {
  object: 'admin/validation-submission-holds-bulk-release',
  data: {
    released: ['staging_validationsubmission_000000DQhold0000000000000001'],
    notHeld: ['staging_validationsubmission_000000DQhold0000000000000002'],
    notFound: ['staging_validationsubmission_000000DQhold0000000000000003']
  }
}
